// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner-border-top[data-v-1b2240d4]{border-top:1px solid #e6ebed;margin-top:0!important;padding-top:40px}.table__grid[data-v-1b2240d4]{grid-template-columns:minmax(50px,auto) minmax(0,-webkit-max-content) -webkit-min-content!important;grid-template-columns:minmax(50px,auto) minmax(0,max-content) min-content!important}.table__grid .full-width[data-v-1b2240d4]{grid-column:1/4!important}.table__grid .no-table-data[data-v-1b2240d4]{color:#9eafb5}", ""]);
// Exports
module.exports = exports;
